import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAuthSellerData, IAuthSellerRequest, IDppManagementPageData } from '../models/models'

export class ListAuthSellerDataApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authSeller/CheckAuthSellerFiles',
      requesterInfo,
    })
  }

  public async ListAuthSellerData(req: IAuthSellerRequest): Promise<IAuthSellerData> {
    return await this.postAsync<IAuthSellerData>(req)
  }
}
